"use strict";

var $ = require("jquery");
var uuid = require("./uuidMIT");

var MultiFactorAuthentication = require("./multi_factor_auth");
var ForgotPassword = require("./forgot-password");

var MAIN_TEMPLATE = "";
var RECIEVE_CODE_TEMPLATE = "";
var ENTER_TOKEN_TEMPLATE = "";
var FORGOT_PASSWORD_TEMPLATE = "";

require("../style/general.scss");
require("../style/uim-widget.scss");
var common = require("./common");
var templatesText = require("../json/TemplatesText.json");

var AUTH_PATH = "/sso/json/msusers/authenticate";
var KEYUP_ABLE = true;

var OPTIONAL_FIELDS = [{
    selector: "#rememberMe-container",
    configKey: "showRememberMe"
}, {
    selector: "#forgotPassword-container",
    configKey: "showForgotPassword"
}, {
    selector: "#notAMember-container",
    configKey: "showNotAMember"
}, {
    selector: "#logo-container",
    configKey: "showLogo"
}, {
    selector: ".ie789-only",
    configKey: "showLabels"
}];

function getRealm() {
    var urlArgs = window.location.search.slice(1).split("&");
    var envArgs = urlArgs.filter(function (value) {
        return (value.substr(0, 6) === "realm=");
    });
    var result;
    if (envArgs.length > 0) {
        var prefix = "realm=";
        var param = envArgs[0].slice(prefix.length);
        result = param;
    } else {
        result = "msusers";
    }
    return result;
}

function validateParams(params) {
    if (!params.configuration.environment) {
        throw new Error("No environment provided to uim widget");
    }

    if (common.SSO_ENVIRONMENTS[params.configuration.environment.toLowerCase()] === undefined) {
        //The STATIC environment is not included in the list as it should not be used by client systems.
        throw new Error("Unknown environment passed. Please choose dev, dev-1, qa, stg, uat, or prod");
    }

    if (!!params.configuration.success && (typeof params.configuration.success !== "function")) {
        throw new Error("Success callback must be a function");
    }

    if (!!params.configuration.error && (typeof params.configuration.error !== "function")) {
        throw new Error("Error callback must be a function");
    }

    if (!!params.configuration.mfa && (typeof params.configuration.mfa !== "function")) {
        throw new Error("MFA callback must be a function");
    }

    if (!!params.configuration.proxyBaseUrl && (typeof params.configuration.proxyBaseUrl !== "string")) {
        throw new Error("Reverse proxy path must be a string");
    }
}

function UimLoginWidget(params) {
    validateParams(params);
    this.isOlderIEVersion = navigator.appVersion.indexOf("MSIE 7.0") > -1 || navigator.appVersion.indexOf("MSIE 8.0") > -1
                            || navigator.appVersion.indexOf("MSIE 9.0") > -1;

    this.successCallback = params.configuration.success || window.morningstar.uim.success;
    this.errorCallback = params.configuration.error || window.morningstar.uim.error;
    this.mfaCallback = params.configuration.mfa || window.morningstar.uim.mfa;
    this.showForgotPassword = params.configuration.showForgotPassword;
    this.showNotAMember = params.configuration.showNotAMember;
    this.notAMemberLink = params.configuration.notAMemberLink;
    this.showRememberMe = params.configuration.showRememberMe;
    this.showLogo = params.configuration.showLogo;
    this.showLabels = this.isOlderIEVersion;
    this.apigeeKey = params.configuration.apigeeKey;
    this.environment = params.configuration.environment.toLowerCase();
    this.baseUrl = common.SSO_ENVIRONMENTS[this.environment];
    this.proxyBaseUrl = params.configuration.proxyBaseUrl;
    this.showLockMsg = params.configuration.showLockMsg;
    this.element = params.element;
    this.locale = common.getUrlParameter("culture");
    this.forgotPasswordReturnURL = params.configuration.forgotPasswordReturnURL;
}

UimLoginWidget.prototype.init = function () {
    var self = this,
        languagesSupport = ["en", "en-us", "en-ca"],
        language = common.getUserPreferredLocale(this.locale, languagesSupport),
        handleBarTemplates = window.morningstar.uim.templates,
        // Select the widget data using language locale
        widgetText = templatesText[language];
    MAIN_TEMPLATE = handleBarTemplates.Login(widgetText.login);
    RECIEVE_CODE_TEMPLATE = handleBarTemplates.ReceiveMfaCode(widgetText.receiveMFA);
    ENTER_TOKEN_TEMPLATE = handleBarTemplates.EnterMfaToken(widgetText.enterMFA);
    FORGOT_PASSWORD_TEMPLATE = handleBarTemplates.ForgotPassword(widgetText.forgotPwd);

    this.element.append(MAIN_TEMPLATE);

    this.loginWidgetParent = this.element.find(".login-widget");
    this.mfaParent = this.element.find(".uim-mfa");
    this.mfaParent.append(RECIEVE_CODE_TEMPLATE);
    this.mfaParent.append(ENTER_TOKEN_TEMPLATE);
    this.receiveLocaleWidget = widgetText.receiveMFA;
    this.enterLocaleWidget = widgetText.enterMFA;

    // default MFA to be hidden
    this.mfaParent.hide();

    this.forgotPasswordParent = this.element.find(".uim-forgot-password");
    this.forgotPasswordParent.append(FORGOT_PASSWORD_TEMPLATE);

    // default forgot password to be hidden
    this.forgotPasswordParent.hide();

    var usernameField = this.element.find("input#uim-uEmail-input");
    var passwordField = this.element.find("input#uim-uPassword-input");
    var submit = this.element.find("input#uim-login-submit");
    var rememberMe = this.element.find("input#remember_me");
    var forgotPassword = this.element.find("a#forgotPassword");
    var notAMember = this.element.find("a#notAMember");

    if (this.isOlderIEVersion) {
        rememberMe.css('z-index',0);
    }
    this.fields = {
        username: usernameField,
        password: passwordField,
        rememberMe: rememberMe
    };

    usernameField.on("blur", function () {
        self.validateFields();
    });

    passwordField.on("blur", function () {
        self.validateFields();
    });

	passwordField.on("keyup", function () {
		if(!KEYUP_ABLE){
			self.validateFields();
		}
    });
	usernameField.on("keyup", function () {
		if(!KEYUP_ABLE){
			self.validateFields();
		}

    });

    submit.on("click enter", function (e) {
        e.preventDefault();
        self.submit({
            username: self.fields.username.val(),
            password: self.fields.password.val()
        });
    });

    forgotPassword.on("click", function (e) {
        e.preventDefault();

        if ((typeof self.forgotPasswordReturnURL!== "undefined") && (self.forgotPasswordReturnURL.length>0)){
            setTimeout(function () {
                window.location.href = self.forgotPasswordReturnURL;
            }, 10);
        } else {
            self.submitForgotPassword({
                locale: language
            });
        }
    });

    notAMember.on("click", function (e) {
        e.preventDefault();
        window.location.assign(self.notAMemberLink);
    });

    for (var index = 0; index < OPTIONAL_FIELDS.length; index++) {
        var field = OPTIONAL_FIELDS[index];

        var showField = this[field.configKey];

        if (showField === false || showField === undefined) {
            common.hideElement(this.element.find(field.selector));
        }
    }
};

UimLoginWidget.prototype.submitForgotPassword = function (params) {
    var self = this;
    this.loginWidgetParent.hide();
    this.mfaParent.hide();
    this.forgotPasswordParent.show();
    var forgotPasswordPage = new ForgotPassword({
        loginWidgetInstance: self,
        language: params.locale,
        email: self.fields.username.val(),
        environment: self.environment,
        apigeeKey: self.apigeeKey,
        forgotPasswordReturnURL: self.forgotPasswordReturnURL
    });
    return forgotPasswordPage.init();
};

UimLoginWidget.prototype.showInputErrors = function (status) {
    if (status === 401) {
        this.element.find("input#uim-uEmail-input").parent().addClass("error");
        this.element.find("input#uim-uPassword-input").parent().addClass("error");
        common.showElement(this.element.find(".uim-message.authentication_error"));
    } else if (!!status) {
        common.showElement(this.element.find(".uim-message.unknown_server_error"));
    }
};

UimLoginWidget.prototype.showAccountLockErrors = function (locked) {
    this.clearErrorMessages();
    this.element.find("input#uim-uEmail-input").parent().addClass("error");
    this.element.find("input#uim-uPassword-input").parent().addClass("error");
    if(locked.status == "accountLockWarn") {
        //var accountLockWarnMessage = this.element.find(".uim-message.account_lock_warning_1").text() + " " + locked.count + " " + this.element.find(".uim-message.account_lock_warning_2").text();
        var accountLockWarnMessage = this.element.find(".uim-message.account_lock_warning_1").text();
        this.element.find(".uim-message.account_lock_warning").text(accountLockWarnMessage);
        common.showElement(this.element.find(".uim-message.account_lock_warning"));
    } else if (locked.status == "accountLocked") {
        common.showElement(this.element.find(".uim-message.account_locked"));
        this.element.find("input#uim-login-submit").prop("disabled", true);
    } else {
        common.showElement(this.element.find(".uim-message.unknown_server_error"));
    }
};

UimLoginWidget.prototype.clearErrorMessages = function () {
    common.hideElement(this.element.find(".uim-message.authentication_error"));
    common.hideElement(this.element.find(".uim-message.unknown_server_error"));
    common.hideElement(this.element.find(".uim-message.required"));
    common.hideElement(this.element.find(".uim-message.account_lock_warning"));
    common.hideElement(this.element.find(".uim-message.account_locked"));
    this.element.find("input#uim-login-submit").prop("disabled", false);
};

UimLoginWidget.prototype.showEmailErrorMessage = function () {
    var email = this.element.find("input#uim-uEmail-input");

    function isValid() {
        var isInternetExplorer = (navigator.appVersion.indexOf("MSIE 7.0") > -1 ) || (navigator.appVersion.indexOf("MSIE 8.0") > -1 ) || (navigator.appVersion.indexOf("MSIE 9.0") > -1);
        var value = email[0].value;
        var isEmptyEmail = value.length === 0;

        if (isEmptyEmail) {
            return true;
        } else if (isInternetExplorer) {
            var regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i;
            // Test with the regex and test for two scenarios that
            // the regex won't catch (double dots or a dot at as the first character).
            return regex.test(value) && value.indexOf(".") != 0 && value.indexOf("..") == -1;
        } else {
            return email[0].validity.valid;
        }
    }

    if (isValid()) {
        email.parent().removeClass("error");
        common.hideElement(this.element.find(".uim-message.email"));
        this.clearErrorMessages();
    } else {
        email.parent().addClass("error");
        common.showElement(this.element.find(".uim-message.email"));
    }
    return isValid();
};

UimLoginWidget.prototype.showPasswordMessage = function () {
    var password = this.element.find("input#uim-uPassword-input");
    var isValid = password[0].value.length < 60;

    if (isValid) {
        password.parent().removeClass("error");
        common.hideElement(this.element.find(".uim-message.maxlength"));
        this.clearErrorMessages();
    } else {
        password.parent().addClass("error");
        common.showElement(this.element.find(".uim-message.maxlength"));
    }
    return isValid;
};

UimLoginWidget.prototype.validateRequiredFields = function () {
    var email = this.element.find("input#uim-uEmail-input");
    var password = this.element.find("input#uim-uPassword-input");

    var isEmptyUsername = this.fields.username.val().length === 0;
    var isEmptyPassword = this.fields.password.val().length === 0;
    var isInvalid = isEmptyUsername || isEmptyPassword;

    if (isInvalid) {
        common.showElement(this.element.find(".uim-message.required"));

        if (isEmptyUsername) {
            email.parent().addClass("error");
        }

        if (isEmptyPassword) {
            password.parent().addClass("error");
        }
    }

    return !isInvalid;
};

UimLoginWidget.prototype.resetToDefault = function () {
    this.mfaParent.hide();
    this.forgotPasswordParent.hide();
    this.loginWidgetParent.show();
};

UimLoginWidget.prototype.validateFields = function () {
    var validEmail = this.showEmailErrorMessage();
    var validPassword = this.showPasswordMessage();
    this.clearErrorMessages();
	KEYUP_ABLE = (validEmail && validPassword);

    return validEmail && validPassword;
};

UimLoginWidget.prototype.getUrl = function (isMFAResponse) {
    var url = "";

    if (typeof this.proxyBaseUrl === "string") {
        url = this.proxyBaseUrl + AUTH_PATH.replace("msusers", getRealm());
    } else {
        url = this.baseUrl + AUTH_PATH.replace("msusers", getRealm());
    }

    var addRememberMe = this.fields.rememberMe[0].checked;
    url = addRememberMe ? url + "?rme=true" : url;

    var seperator = addRememberMe ? "&" : "?";
    return isMFAResponse ? (url + seperator + "authIndexType=service&authIndexValue=mfaService") : url;
};

UimLoginWidget.prototype.isAccountLocked = function(responseJson) {
    if (responseJson.errorMessage.indexOf('locked') > -1) {
        return true;
    } else {
        return false;
    };
};

UimLoginWidget.prototype.getRemainingAttemp = function(responseJson) {
/*    if(responseJson.code != '401') {
        return "-1";
    }*/
    var accountLockWarn1 = 'locked out after ';
    var accountLockWarn2 = ' more failure(s).';
    var message = responseJson.errorMessage;
    var index1 = message.indexOf(accountLockWarn1);
    var index2 = message.indexOf(accountLockWarn2);
    if(index1 == -1 || index2 == -1) {
        return "-1";
    }
    var count = message.substr(index1 + accountLockWarn1.length, index2 - index1 - accountLockWarn1.length);

    return count;
};

UimLoginWidget.prototype.handleAccountLock = function(response, status, error) {
    var self = this;

    if(response.status != 401) {
        return undefined;
    }

    if(response.responseJSON === undefined) {
        return undefined;
    }

    var responseJson = response.responseJSON;
    var count = self.getRemainingAttemp(responseJson);
    if( parseInt(count, 10) > 0 ) {
        console.log("Remaining attemp is " + count);
        return {status: "accountLockWarn", "count": count};
    }

    if(self.isAccountLocked(responseJson)) {
        console.log("Account is locked");
        return {status: "accountLocked"};
    }

};

UimLoginWidget.prototype.submit = function (params, callback) {
    var self = this;

    var isValid = this.validateFields();
    var requiredCheck = this.validateRequiredFields();
    if (!isValid || !requiredCheck) {
        return;
    }
    var requestId = uuidv1();

    $.ajax({
        method: "POST",
        url: this.getUrl(params.isMFAResponse),
        xhrFields: {
            withCredentials: true
        },
        data: "",
        headers: {
            "Content-Type": "application/json",
            "X-OpenAM-Username": params.username,
            "X-OpenAM-Password": params.password,
            "X-API-RequestId": requestId
        }
    })
    .success(function(data, status) {
        self.successCallback(data, status);
    })
    .error(function (response, status, error) {
        // MFA comes back as a 401, so let's parse the response header (for some reason this is in a header)
        // then start the MFA challenge
        var mfaChallenge = response.getResponseHeader("TRANSACTION");
        if (typeof mfaChallenge === "string") {
            self.loginWidgetParent.hide();
            self.forgotPasswordParent.hide();
            self.mfaParent.show();

            try {
                mfaChallenge = JSON.parse(mfaChallenge);
                self.clearErrorMessages();
            } catch (err) {
                self.showInputErrors(response.status);
                self.errorCallback(new Error("Problem logging in"), response.status);

                // throw error on next tick
                setTimeout(function () {
                    throw err;
                }, 0);
            }

            var multiFactorAuthentication = new MultiFactorAuthentication({
                loginWidgetInstance: self,
                mfaChallenge: mfaChallenge
            });

            if(self.mfaCallback !== undefined) {
               self.mfaCallback(response.status);
            }
            return multiFactorAuthentication.init(requestId);
        }

        if (callback && params.isMFAResponse) {
            return callback(response, response.status, error);
        }

        var accountLock = self.handleAccountLock(response, response.status, error);
        if(accountLock === undefined || self.showLockMsg === false) {
            self.showInputErrors(response.status);
        } else {
            self.showAccountLockErrors(accountLock);
        }
        self.errorCallback(new Error("Problem logging in"), response.status);
		KEYUP_ABLE = false;
    });
};

module.exports = {
    createComponent: function (params) {
        var uimWidget = new UimLoginWidget(params);
        uimWidget.init();

        return {
            setProperty: function () {},
            destroy: function () {
                params.element.children().remove();
            }
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/cdsso.js
// module id = 47
// module chunks = 0